import script from "./empty-state.vue?vue&type=script&lang=tsx"
export * from "./empty-state.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__